import React from 'react'
import {Col, Divider, Row, Descriptions, Table} from "antd";
import gib from '../../../logo/gibLogo.png'
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import {currentTime} from "../../../services/formatters/getCurrentTime";
import config from "../../../config";


const gibStyle = {
    width: '128px',
    height: '128px',
};

const dividerStyle = {
    borderTop: '1px solid black',
};

class ShippingOrderPrint extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showCodes: false,
            tenantInfo: config.address[config.currentTenant()],
            stockCodeColumns: [
                {
                    title: '#',
                    key: 'index',
                    render: (text, record, index) => index + 1
                },
                {
                    title: 'Sipariş Kodu',
                    render: (t, r) => r.customerStockCode
                },
                {
                    title: 'AÇIKLAMA',
                    render: (t, r) => `${r.stock.name} - ${r.stock.code}`
                },
                {
                    title: 'MİKTAR',
                    render: (t, r) => r.quantity
                }
            ],
            columns: [
                {
                    title: '#',
                    key: 'index',
                    render: (text, record, index) => index + 1
                },
                {
                    title: 'AÇIKLAMA',
                    render: (t, r) => `${r.stock.name} - ${r.stock.code}`
                },
                {
                    title: 'MİKTAR',
                    render: (t, r) => r.quantity
                }
            ]
        }
    }

    componentDidMount() {
        this.props.shipping.shippingOrderContentList.map(item => {

            if (item.customerStockCode) {
                this.setState({showCodes: true})
            }

        })
    }

    render() {
        return (
            <React.Fragment>
                <div style={{padding: '26px', fontSize: '16px'}}>
                    <Row justify={'space-between'}>
                        <Col span={10}>
                            <Divider style={dividerStyle}/>
                            <p>{this.state.tenantInfo.companyName}</p>
                            <p>{this.state.tenantInfo.st}</p>
                            <p>Tel: {this.state.tenantInfo.phone}</p>
                            <p>Fax: {this.state.tenantInfo.pbx}</p>
                            <p>Vergi Dairesi: {this.state.tenantInfo.taxOffice}</p>
                            <p>VKN: {this.state.tenantInfo.taxNo}</p>
                            <Divider style={dividerStyle}/>
                        </Col>
                        <Col span={12}>
                            <img src={gib} style={gibStyle} alt=""/>
                            <div style={{paddingLeft: '16px', marginTop: '16px'}}>
                                <h5>e-İRSALİYE</h5>
                            </div>
                        </Col>
                    </Row>
                    <Row justify={'space-between'}>
                        <Col span={10}>
                            <Divider style={dividerStyle}/>
                            <h6>SAYIN</h6>
                            <p>{this.props.shipping.customer.name}</p>
                            <p>{this.props.shipping.customerAddress.address}</p>
                            <div style={{marginTop: '32px'}}>
                                <Descriptions>
                                    <Descriptions.Item span={3} label={'E-posta'}>
                                        {this.props.shipping.customer.email}
                                    </Descriptions.Item>
                                    <Descriptions.Item span={3} label={'Tel'}>
                                        {this.props.shipping.customer.mobilePhone}
                                    </Descriptions.Item>
                                    <Descriptions.Item span={3} label={'Vergi Dairesi'}>
                                        {this.props.shipping.customer.taxOffice}
                                    </Descriptions.Item>
                                    <Descriptions.Item span={3} label={'VKN'}>
                                        {this.props.shipping.customer.taxNo}
                                    </Descriptions.Item>
                                    {
                                        this.props.shipping.shippingType === 'CARGO'
                                            ? <Descriptions.Item span={3} label={'Teslimat'}>
                                                {this.props.shipping.customer.cargoCompany || '-'}
                                              </Descriptions.Item>
                                            : <Descriptions.Item span={3} label={'Teslimat '}>
                                                {config.shipmentTypes[this.props.shipping.shippingType.toUpperCase()] || '-'}
                                            </Descriptions.Item>
                                    }
                                </Descriptions>
                            </div>
                            <Divider style={dividerStyle}/>
                        </Col>
                        <Col span={8}>
                            <div style={{marginTop: '24px'}}>
                                <Descriptions bordered size={'small'}>
                                    <Descriptions.Item
                                        span={3}
                                        label={'Senaryo'}
                                    >
                                        <span>TEMELIRSALIYE</span>
                                    </Descriptions.Item>
                                    <Descriptions.Item
                                        span={3}
                                        label={'İrsaliye No'}
                                    >
                                        {this.props.shipping.dispatchNo}
                                    </Descriptions.Item>
                                    <Descriptions.Item
                                        span={3}
                                        label={'Müşteri Sipariş No'}
                                    >
                                        {this.props.shipping.customerOrderNo}
                                    </Descriptions.Item>
                                    <Descriptions.Item span={3} label={'Ödeme'}>
                                        {this.props.shipping.bid.payment}
                                    </Descriptions.Item>
                                    <Descriptions.Item
                                        span={3}
                                        label={'İrsaliye Tarihi'}
                                    >
                                        {userDateFormatter(this.props.shipping.createdDate)}
                                    </Descriptions.Item>
                                    <Descriptions.Item
                                        span={3}
                                        label={'İrsaliye Zamanı'}
                                    >
                                        {userDateFormatter(this.props.shipping.shipmentDate)}
                                    </Descriptions.Item>
                                    <Descriptions.Item
                                        span={3}
                                        label={'Sevk Tarihi'}
                                    >
                                        {userDateFormatter(this.props.shipping.shipmentDate)}
                                    </Descriptions.Item>
                                    <Descriptions.Item
                                        span={3}
                                        label={'Sevk Zamanı'}
                                    >
                                        {
                                            currentTime()
                                        }
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </Col>
                    </Row>
                    <Row justify={'center'}>
                        <Col span={24}>
                            <div>
                                <Table bordered
                                       pagination={false}
                                       size={'small'}
                                       columns={this.state.showCodes ? this.state.stockCodeColumns : this.state.columns}
                                       dataSource={this.props.shipping.shippingOrderContentList}
                                       rowKey={'id'}
                                />
                            </div>
                        </Col>
                    </Row>
                    <div style={{marginTop: "16px"}}>
                        <Divider style={{marginBottom: "4px"}}/>
                        <Row justify={"start"}>
                            <Col span={24}>
                                <span className={'print-note'}>{this.props.shipping.note}</span>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default ShippingOrderPrint